import React, { useState } from 'react';

const Support = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    priority: 'normal'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link with form data
    const subject = encodeURIComponent(`${formData.priority.toUpperCase()} Support: ${formData.subject}`);
    const body = encodeURIComponent(`
Name: ${formData.name}
Email: ${formData.email}
Priority: ${formData.priority.toUpperCase()}

Message:
${formData.message}

---
This message was sent from the Alium Software support form.
    `);
    
    window.location.href = `mailto:support@aliumsoftware.com?subject=${subject}&body=${body}`;
  };

  return (
    <section id="support" className="support">
      <div className="support-container">
        <div className="section-header">
          <h2 className="section-title">Professional Support</h2>
          <p className="section-description">
            We're here to help you succeed. Our expert support team is ready to assist 
            with your technical challenges, project questions, and strategic guidance.
          </p>
        </div>

        <div className="support-content">
          <div className="support-info">
            <div className="support-card">
              <div className="support-icon">
                <div className="icon-circle">
                  <span>💼</span>
                </div>
              </div>
              <h3>Enterprise Support</h3>
              <p>
                Dedicated technical support for your mission-critical applications. 
                Our team understands the complexities of modern business technology.
              </p>
            </div>

            <div className="support-card">
              <div className="support-icon">
                <div className="icon-circle">
                  <span>🚀</span>
                </div>
              </div>
              <h3>Fast Response</h3>
              <p>
                Quick turnaround times ensure your business stays running smoothly. 
                Priority support available for urgent technical issues.
              </p>
            </div>

            <div className="support-card">
              <div className="support-icon">
                <div className="icon-circle">
                  <span>🎯</span>
                </div>
              </div>
              <h3>Expert Guidance</h3>
              <p>
                Strategic technology consulting to help you make informed decisions 
                about your digital transformation journey.
              </p>
            </div>
          </div>

          <div className="support-form-section">
            <div className="form-header">
              <h3>Get Professional Support</h3>
              <p>Reach out to our team for expert assistance with your technical needs.</p>
            </div>

            <form onSubmit={handleSubmit} className="support-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                    placeholder="Brief description of your inquiry"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="priority">Priority Level</label>
                  <select
                    id="priority"
                    name="priority"
                    value={formData.priority}
                    onChange={handleInputChange}
                  >
                    <option value="low">Low - General inquiry</option>
                    <option value="normal">Normal - Standard support</option>
                    <option value="high">High - Business impact</option>
                    <option value="urgent">Urgent - Critical issue</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  placeholder="Please provide details about your support request..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Send Support Request
              </button>
            </form>

            <div className="direct-contact">
              <p>
                <strong>Direct Email:</strong> 
                <a href="mailto:support@aliumsoftware.com">support@aliumsoftware.com</a>
              </p>
              <p className="support-note">
                For urgent matters, please mark your email as "URGENT" in the subject line. 
                We typically respond to support requests within 24 hours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;